import React, { useEffect, useMemo, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import { deleteWocommercePricing } from "../../../actions/wocommerce-pricing/wocommerce";
import { fetchWocommerceDataPricing } from "../../../actions/wocommerce-pricing/wocommerce";
import { fetchSingleWocommerce } from "../../../actions/wocommerce-pricing/wocommerce";
import { useWocommercePriceUIContext } from "../WocommercePriceUIContext";

export function WocommercePriceDeleteDialog({ show, onHide, id }) {
  
  // Products UI Context
  const priceUIContext = useWocommercePriceUIContext();
  const priceUIProps = useMemo(() => {
    return {
      ids: id,
      queryParams: priceUIContext.queryParams,
      setQueryParams: priceUIContext.setQueryParams,
    };
  }, [priceUIContext, id]);

  // Products Redux state
  const dispatch = useDispatch();

  const { enqueueSnackbar } = useSnackbar();
  
  

  // if there weren't selected products we should close modal
  useEffect(() => {
    if (!priceUIProps.ids || priceUIProps.ids.length === 0) {
      onHide();
    } else {
      dispatch(fetchSingleWocommerce(priceUIProps.ids));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, priceUIProps.ids]);

  const deleteWocommerce = () => {
    // server request for deleting product by seleted ids
    enableLoading();
    dispatch(deleteWocommercePricing(id)).then(async (data) => {
      
      onHide();

      await dispatch(fetchWocommerceDataPricing());

      await enqueueSnackbar('Wocommerce Pricing deleted successfully', {
        variant: "success",
        autoHideDuration: 4500,
      });

      disableLoading();
    });
  };

  const [loading, setLoading] = useState(false);

  const enableLoading = () => {
    setLoading(true);
  };

  const disableLoading = () => {
    setLoading(false);
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby='example-modal-sizes-title-lg'>
      {loading}
      <Modal.Header closeButton>
        <Modal.Title id='example-modal-sizes-title-lg'>
         Wocommerce pricing Delete
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!loading && (
          <span>Are you sure you want to remove</span>
        )}
        {loading && <span>Please wait,Wocommerce pricing is deleting...</span>}
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type='button'
            onClick={onHide}
            className='btn btn-light btn-elevate'>
            Cancel
          </button>
          <> </>
          <button
            type='button'
            onClick={deleteWocommerce}
            className='btn btn-primary btn-elevate'
            disabled={loading ? true : false}>
            Delete
            {loading && (
              <span className='ml-3 spinner px-2 spinner-white'></span>
            )}
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
